import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import Channel from "ui/common/channel/Channel";
import { focusChannel } from "actions/ui";
import {Scrollbar} from "react-scrollbars-custom";
import CloseButton from "ui/common/channel/components/CloseButton";
import StreamStatus from "../../../common/channel/components/streams/StreamStatus";

class GridController extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			channelClicked: false
		}

		this.scrollRef = React.createRef();

		this.handleClick = this.handleClick.bind(this);
	}

	handleClick(channelId) {
		this.setState({ channelClicked: true }, () => { this.props.focusChannel(channelId); });
	}

	getOpenedChannels() {
		return this.props.openedChannels
			.filter( channelId => this.props.channels.find( channel => channel.id === channelId && (this.props.configuration.interface.chat.publicEnabled || channel.type === 'direct')) )
			.map( channelId => this.props.channels.find( channel => channel.id === channelId) );
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.focusedChannel !== this.props.focusedChannel) {
			if (this.state.channelClicked) {
				this.setState({ channelClicked: false });
			} else {
				const openedChannels = this.getOpenedChannels().map(channel => channel.id);
				const index = openedChannels.indexOf(this.props.focusedChannel);

				if (index >= 0) {
					const cols = Math.min(openedChannels.length, this.props.configuration.interface.chat.classic.grid.cols);
					const row = Math.floor(index / cols);

					this.scrollRef.current.scrollTo(0, row * this.props.configuration.interface.chat.classic.grid.height);
				}
			}
		}
	}

	render() {
		const openedChannels = this.getOpenedChannels();
		const widthClass = 'wcGridChannel' + Math.min(openedChannels.length, this.props.configuration.interface.chat.classic.grid.cols);

		return(
			<React.Fragment>
				<Scrollbar ref={ this.scrollRef } noScrollX={ true }>
					<div className="wcGrid">
						{ openedChannels.map( channel =>
							<div key={ channel.id }
							     className={ `wcGridChannelContainer ${widthClass}` + (channel.id === this.props.focusedChannel ? ' wcFocused' : '') }
							     onClick={ e => this.handleClick(channel.id) }
							>
								<div className="wcGridChannel">
									<div className="wcHeader">
										<div className="wcMain">
											<span className="wcName">{ channel.name }</span>
											<StreamStatus channel={ channel } />
										</div>
										{ (this.props.publicChannels.length > 1 || channel.type === 'direct') && <CloseButton channel={channel} focusOnClose={ true } /> }
									</div>
									<Channel channel={ channel } />
								</div>
							</div>
						)}
						{ this.props.channels.length > 0 && !openedChannels.find( channel => channel.id === this.props.focusedChannel) &&
							<div className="wcGridFull">
								<span className="wcEmpty">{ this.props.i18nBase.noChannels }</span>
							</div>
						}
					</div>
				</Scrollbar>
			</React.Fragment>
		)
	}

}

GridController.propTypes = {
	configuration: PropTypes.object.isRequired,
	channels: PropTypes.array.isRequired,
	publicChannels: PropTypes.array.isRequired
};

export default connect(
	(state) => ({
		configuration: state.configuration,
		i18nBase: state.configuration.i18n,
		channels: state.application.channels,
		focusedChannel: state.ui.focusedChannel,
		openedChannels: state.ui.openedChannels,
		publicChannels: state.application.channels.filter( channel => channel.type !== 'direct' ),
	}),
	{ focusChannel }
)(GridController);